import sha256 from 'crypto-js/sha256';
async function hashString(str, size) {
    const encoder = new TextEncoder();
    const data = encoder.encode(str).toString();
    const hashStr = sha256(data).toString();
    return size ? hashStr.slice(0, size) : hashStr;
}
/**
 * 根据指定长度，生成随机字符串，字符串只会包含英文字母的大小写
 * @param size 字符串长度
 */
export function getRandomString(size) {
    const alphabet = 'abcdefghijklmnopqrstuvwxyz';
    const dict = alphabet + alphabet.toUpperCase();
    const result = [];
    for (let i = 0; i < size; i++) {
        const index = Math.floor(Math.random() * dict.length);
        result.push(dict.charAt(index));
    }
    return result.join('');
}
export default hashString;
